// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54292a4b","455":"38e09d7b","977":"0d22bb99"}[chunkId] + ".chunk.js";
};